module.exports = __webpack_public_path__ + "static/media/Nou_size_correction_optimized2.33b80e72.png";